import { render, staticRenderFns } from "./LogisticsWeekDaySelector.vue?vue&type=template&id=2ae102c7&scoped=true"
import script from "./LogisticsWeekDaySelector.vue?vue&type=script&lang=js"
export * from "./LogisticsWeekDaySelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae102c7",
  null
  
)

export default component.exports